<script>
  import _ from "lodash";
  import { step } from "../stores";

  let currentQuestionIndex = 0;

  const questions = [
    {
      question:
        "Sei interessato ad un prestito?",
      answers: [
        "SI, sono interessato",
        "NO, non mi interessa",
        "Voglio altre info",
      ],
    },
  ];

  const onSubmit = (s) => {
    step.set(s);
    window.scrollTo(0, 0);
  };
</script>

<div class="container">
  <div class="columns">
    <div class="column" style="text-align: center">
      <div style="text-align: center; margin-top: 48px;">
        <h2>{questions[currentQuestionIndex].question}</h2>
      </div>
    </div>
  </div>

  <div style="max-width: 450px; margin: 0 auto;">
    {#each questions[currentQuestionIndex].answers as answer}
      <button
        on:click={(e) => {
          return onSubmit(
            answer === questions[currentQuestionIndex].answers[0] ? 0 : 3
          );
        }}>{answer}</button
      >
    {/each}
  </div>
</div>

<style>
  .container {
    max-width: 700px;
    text-align: center;
  }

  button {
    cursor: pointer;
    display: block;
    width: 100%;
    padding: 16px;
    background-color: #2ecc71;
    color: white;
    font-weight: 700;
    text-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
    text-transform: uppercase;
  }
</style>
